import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import './scss/style.scss';
import { translate } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        display: 'inline-block',
        maxHeight: '100vh',
        overflow: 'auto'
    },
}));

function LinksModal(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(true);

    const close = () => {
        setOpen(false);
        props.onClose();
    }
    useEffect(() => {
        setOpen(props.open)
    }, [props.open])

    const triggerFunc = (val) => {
        close()
        if (val) {
            props.triggerFunc(val);
        }
    }

    return (
        <div>
            <Modal
                open={open}
                onClose={close}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                classes={classes.modal}
                aria-labelledby="spring-modal-title"
                aria-describedby="spring-modal-description">
                <Fade in={open}>
                    <div className={classes.paper}>
                        <div className="modal-sms-service" style={{ width: '550px' }}>
                            {props.links && props.links.length > 0 &&
                                <div className="modal-sms-service-buttons flex-column align-items-center" style={{ rowGap: '1rem' }}>
                                    {props.links.map(item =>
                                        <button className="modal-sms-service-button-yes d-flex justify-content-between align-items-center" onClick={() => window.open(item?.link)}>
                                            <span style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', maxWidth: '200px'}}>{item?.linkName}</span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 18 19" fill="none">
                                                <path d="M7.49331 4.24988H6.14331C5.30323 4.24988 4.88288 4.24988 4.56201 4.41337C4.27977 4.55718 4.05046 4.78648 3.90665 5.06873C3.74316 5.38959 3.74316 5.80995 3.74316 6.65002V12.35C3.74316 13.1901 3.74316 13.6099 3.90665 13.9308C4.05046 14.213 4.27977 14.4427 4.56201 14.5865C4.88257 14.7499 5.30241 14.7499 6.14085 14.7499H11.8455C12.6839 14.7499 13.1032 14.7499 13.4237 14.5865C13.706 14.4427 13.936 14.2128 14.0798 13.9306C14.2432 13.61 14.2432 13.1906 14.2432 12.3522V10.9999M14.9932 7.24988V3.49988M14.9932 3.49988H11.2432M14.9932 3.49988L9.74316 8.74988" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </button>)}
                                </div>
                            }
                            <div className="modal-sms-service-buttons">
                                <button className="modal-sms-service-button-no ml-0" onClick={() => triggerFunc(false)}>{props.t('close')}</button>
                            </div>
                        </div>
                    </div>
                </Fade>
            </Modal>
        </div>
    );
}

export default translate("translation")(LinksModal);